$(document).ready(function () {
	'use strict';
	// navbar js start ---
	$(window).on('load scroll', function () {
		var scrolling = $(this).scrollTop();
		if (scrolling > 100) {
			$('.navbar').addClass('nav-fixed')
		} else {
			$('.navbar').removeClass('nav-fixed')
		}
	})

	$(".ham-menu").click(function (event) {
		event.stopPropagation();
		$(".sidebar-wrapper").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".sidebar-wrapper-inner").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".mobile-menu-close-window-btn").click(function (event) {
		event.stopPropagation();
		$(".sidebar-wrapper").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".sidebar-wrapper-inner").toggleClass("active");
		$("body").toggleClass("active");
	});

	// **..mobile-dropdown-accordion js start..**
	$('.sidebar-submenu-open').on('click', function () {
		$(this).parent().find(".megamenu-wrapper").addClass('active');
	});

	$('.sidebar-close-btn').on('click', function () {
		$(this).parent().parent().parent(".megamenu-wrapper").removeClass('active');
	});
	// **..mobile-dropdown-accordion js end..**

	$(".search-bar-open-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(".search-bar-window-close-btn").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".search-bar-window-close-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(this).toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".search-close-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(".search-bar-window-close-btn").toggleClass("active");
		$("body").toggleClass("active");
	});

	// navbar js end ---

	// cart-sidebar js start---
	$(".cart-sidebar-open-btn").click(function (event) { 
		event.preventDefault();
		$(".cart-sidebar").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".cart-sidebar-close-window-btn").click(function (event) {
		event.stopPropagation();
		$(".cart-sidebar").removeClass("active");
		$("body").toggleClass("active");
	});

	$(".side-cart-close-btn").click(function (event) {
		event.stopPropagation();
		$(".cart-sidebar").toggleClass("active");
		$("body").toggleClass("active");
	});
	// cart-sidebar js end---

	// --tab js start--
	$('.tab-btn').click(function () {
		$('.tab-nav-item').removeClass('active');
		$(this).parent().addClass('active');
		$('.tab-content-item').hide();

		var activeTab = $(this).attr('href');
		$(activeTab).fadeIn();
		return false;
	});
	// --tab js end--

	$(".card-varient-tap-btn").click(function () {
		$(this).closest(".product-card").find(".product-varient").addClass("active");
	})

	$(".product-varient").click(function (e) {
		e.stopPropagation();
	})

	// **..product-accordion js start..**
	$('.product-accordion-toggle-btn').on('click', function () {
		$(this).next().slideToggle();
		$(this).parent().toggleClass('active');
		$(this).parent().siblings().removeClass('active').find('.product-accordion-item-content').slideUp();
	});
	// **..product-accordion js end..**

	

	$(".card_option").on("change", function () {
		let optionName = "";

		if($(this).hasClass("color_Swatch_option")){
			updateSwiperById($(this).attr("data-media-id"), $(this).closest(".product-card").find(".card-slider"));
			return;
		}

		// Get selected option value
		$(this).closest('.product-options').find(".card_option:checked").each(function (e) {
			optionName += e !== 0 ? "-" : "";
			optionName += $(this).val();
		});
		let $card = $(this).closest(".product-card");
 		let $select = $(this).closest('.product-varient').find('.productSelect');

		$select.find("option").each(function () {
			var txt = $.trim($(this).text());
			if (txt === optionName) {
				var img = $(this).data("img");
				var id = $(this).val();
				var variantId = $(this).val();
				$select.val($(this).val()).trigger('change'); // select it
				var price = $(this).data("price");
				var compare_price = $(this).data("compare");
				var available = $(this).data("available");

				if (!available) {
                alert('Sold Out');
                return;
            }

			const productTags = $card.find('.card-product-tags').val().split(',');
            const isGift100 = productTags.includes("gift-100");
            const isGift150 = productTags.includes("gift-150");
			console.log(isGift100,isGift150,variantId,available,"variantId,variantId")

			 // ---------- IF GIFT PRODUCT ----------
            if (isGift100 || isGift150) {
                tryAddGift(variantId, isGift100, isGift150, function(){
				$(".cart-sidebar").addClass("active");
				$("body").addClass("active");
			});
                return; // STOP – don't add normally
            }

				// $("#productSelect").val(id);
					$.ajax({
						type:'POST',
						url:'/cart/add.js',
						// data:$('#product_form').serialize(),
						data: { id: id, quantity: 1 },
						dataType:'json',
						success:function(data) {
							$(".cart-sidebar").addClass("active");
							$("body").addClass("active");
							cart_drawer_update();
						},
						error:function(err) {
							console.log('Error', err);
						}
					})

			
			}
		});
	});

	

	$(".card_option_upsell").on("change", function () {
		let optionName = "";

		

		// Get selected option value
		$(this).closest('.product-options').find(".card_option_upsell:checked").each(function (e) {
			optionName += e !== 0 ? "-" : "";
			optionName += $(this).val();
		});
 		let $select = $(this).closest('.product-varient').find('.productSelect');
 		let $id = $(this).closest('.side-cart-slider-item-content').find('.product_id');

		

		$select.find("option").each(function () {
			// console.log('optionName ' +optionName)
			// console.log('txt ' + txt)
			// alert('optionName ' + optionName);
			var txt = $.trim($(this).text());
			if (txt === optionName) {
				var img = $(this).data("img");
				var id = $(this).val();
				$select.val($(this).val()).trigger('change'); // select it
				var price = $(this).data("price");
				var compare_price = $(this).data("compare");
				var available = $(this).data("available");

				$select.val(id);
				$id.val(id);
			
			}
		});
	});

	// Funktion zum Aktualisieren der Verfügbarkeit
function updateVariantAvailability() {
    let optionName = "";
    
    // Get selected option value
    $("input:radio.option_input:checked").each(function (e) {
        optionName += e !== 0 ? "-" : "";
        optionName += $(this).val();
    });

    $("#productSelect option").each(function () {
        var txt = $.trim($(this).text());
        if (txt === optionName) {
            var img = $(this).data("img");
            var id = $(this).val();
            var price = $(this).data("price");
            var compare_price = $(this).data("compare");
            var available = $(this).data("available");
            var inventory = $(this).data("inventory");
            
            console.log(available, inventory, id, "ididid");
            $("#productSelect").val(id);
            $("#product_id").val(id);

            // Prüfe inventory statt available
            if (inventory > 0) {
                $(".addToCart").removeClass("sold_out");
                $(".atc-text").text("Add To Cart");
                
                $(".product-details-availability-text").html(
                    '<span class="icon"></span>' +
                    '<p>' + window.stockTexts.inStock + ' – ' + window.stockTexts.delivery + '</p>'
                );
                
            } else {
                $(".addToCart").addClass("sold_out");
                $(".atc-text").text("Sold Out");
                
                $(".product-details-availability-text").html(
                    '<span class="icon"></span>' +
                    '<p class="stock_out">' + window.stockTexts.outOfStock + '</p>'
                );
            }

            $(".featured-img").each(function (index) {
                var src = $(this).attr("src").split("?")[0];
                var cleanImg = img.split("?")[0];
                if (src === cleanImg) {
                    swiper2.slideToLoop(index, 500, false);
                }
            });
        }
    });
}

// Beim Laden der Seite ausführen
$(document).ready(function() {
    updateVariantAvailability();
});

// Bei Änderung der Variante
$(".option_input").on("change", function () {
    var vname = $(this).val();
    $(this).closest('.product-details-varient').find('.selected_option').text(vname);
    updateVariantAvailability();
});

	$('.addToCart').on('click', function(e){
		e.preventDefault();
		const form = $(this).closest('#product_form');
		const price = parseInt(form.find('.product-price').val()); // price in cents
		const isGift = (price === 0);
		console.log(isGift,"isGift")
		if(!isGift){
			 $.ajax({
            type:'POST',
            url:'/cart/add.js',
            data:form.serialize(),
            dataType:'json',
            success:function(data) {
                $(".cart-sidebar").addClass("active");
                $("body").addClass("active");
                cart_drawer_update();
            }
        });
        return;
		}
		const productTags = form.find('.product-tags').val().split(','); 
		const isGift100 = productTags.includes("gift-100");
		const isGift150 = productTags.includes("gift-150");
		const variantId = form.find('#product_id').val();
		tryAddGift(variantId, isGift100, isGift150, function(){
        $(".cart-sidebar").addClass("active");
        $("body").addClass("active");
    });
		
		
	});

	$('.upsellAddToCart').on('click', function(e){
		e.preventDefault();

		$.ajax({
			type:'POST',
			url:'/cart/add.js',
			data:$(this).closest('.upsell_form').serialize(),
			dataType:'json',
			success:function(data) {
				$(".cart-sidebar").addClass("active");
				$("body").addClass("active");
				cart_drawer_update();
			},
			error:function(err) {
				console.log('Error', err);
			}
		})
	})
//custom gift code
	$(document).on('click', '.gift-add-btn', function(e) {
		e.preventDefault();
		  const parent = $(this).closest(".gift-item");
		const variantId = parent.find(".gift-variant-select").val();
		const giftproductTags = parent.find('.gift-product-tags').val().split(','); 
		const isGift100 = giftproductTags.includes("gift-100");
    	const isGift150 = giftproductTags.includes("gift-150");
		console.log(variantId,parent,"parent,parent");
		// gift function
		tryAddGift(variantId, isGift100, isGift150);

	})
//end here 

// custom Code 
function tryAddGift(variantId, isGift100, isGift150, callback) {
	console.log(variantId,isGift100,isGift150)
    $.ajax({
        url: "/cart.js",
        type: "GET",
        dataType: "json",
        success: function (cart) {

            const giftExists = cart.items.some(item =>
                item.properties && item.properties.gift
            );
			console.log(giftExists,"giftExists")

            let cartTotal = cart.total_price / 100; 
			console.log(cartTotal,"cartTotal")

            // ❌ Stop if gift already exists
            if (giftExists) {
                alert("You have already selected your free gift.");
                return;
            }

            // ❌ Stop if not eligible
            if (isGift100 && cartTotal < 100) {
                alert("You must spend €100 to unlock this gift.");
                return;
            }

            if (isGift150 && cartTotal < 150) {
                alert("You must spend €150 to unlock this gift.");
                return;
            }

            // If all checks passed → ADD GIFT
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    id: variantId,
                    quantity: 1,
                    properties: {
                        gift: isGift150 ? "150 Spend Gift" : "100 Spend Gift"
                    }
                },
                dataType: "json",
                success: function () {
                    cart_drawer_update();
                    if (callback) callback();
                },
                error: function (xhr) {
                    console.error("Error adding gift:", xhr.responseText);
                }
            });
        }
    });
}

// End Here 

})

const navbar = document.querySelector(".navbar");
let lastScrollPosition = 0;
window.addEventListener("scroll", () => {
	let currentScrollPosition = window.pageYOffset;

	if (currentScrollPosition - lastScrollPosition > 22) {
		navbar.classList.add("hide");
		navbar.classList.remove("nav-fixed");
	} else {
		navbar.classList.add("nav-fixed");
		navbar.classList.remove("hide");
	}
	lastScrollPosition = currentScrollPosition;
})


// btn js ---
// primary btn---
$(function () {
	$('.primary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
});

// secondary btn--
$(function () {
	$('.secondary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
});
// btn js ---

// card slider js start--

  var swiper3 = new Swiper(".card-slider", {
    slidesPerView: 1,
    spaceBetween: 4,
    loop: false,
    navigation: {
      nextEl: ".card-slider-button-next",
      prevEl: ".card-slider-button-prev",
    },
  });


function updateSwiperById(id, swatches) {
	var slides = swatches.find(".swiper-slide")
	var index = 0;
	for (let i = 0; i < slides.length; i++) {
		const element = $(slides[i]).attr("data-media-id");

		if (element == id) {
			index = i;
		}
		
	}

	$(swatches)[0].swiper.slideTo(index)
}

// card slider js end--


var swiper = new Swiper(".side-cart-item-slider", {
	slidesPerView: 1.5,
	spaceBetween: 10,
	grabCursor: true,
	loop: false,
	navigation: {
		nextEl: '.side-cart-slider-btn-next',
		prevEl: '.side-cart-slider-btn-prev',
	},
	breakpoints: {
		1: {
			slidesPerView: 1.2,
		},
		440: {
			slidesPerView: 1.5,
		}
	}
});
// gift tire
// var swiper = new Swiper(".gift-tier-100", {
// 	slidesPerView: 1.5,
// 	spaceBetween: 10,
// 	grabCursor: true,
// 	loop: false,
// 	navigation: {
// 		nextEl: '.side-cart-slider-btn-next',
// 		prevEl: '.side-cart-slider-btn-prev',
// 	},
// 	breakpoints: {
// 		1: {
// 			slidesPerView: 1.2,
// 		},
// 		440: {
// 			slidesPerView: 1.5,
// 		}
// 	}
// });
// side-cart-item-slider js end--

// img-gallery slider js start--
var swiper = new Swiper(".img-gallery-slider", {
	infinity: true,
	slidesPerView: 4.5,
	spaceBetween: 4,
	grabCursor: true,
	loop: true,
	speed: 500,
	 autoplay: {
		delay: 4000,
		disableOnInteraction: true,
		
	},
	breakpoints: {
		// when window width is >= 320px
		1: {
			slidesPerView: 1.25,
		},
		// when window width is >= 768px
		576: {
			slidesPerView: 3.2,
		},
		// when window width is >= 993px
		993: {
			slidesPerView: 3.5,
		},
		// when window width is >= 1140x
		1140: {
			slidesPerView: 4.5,
		},
		// when window width is >= 1290px
		1290: {
			slidesPerView: 4.5,
		}
	}
});
// img-gallery slider js end--

// testimonial slider js start--
var swiper = new Swiper(".testimonial-slider", {
	slidesPerView: 3.5,
	spaceBetween: 10,
	grabCursor: true,
	loop: false,
	scrollbar: {
		el: ".swiper-scrollbar",
		hide: true,
	},
	breakpoints: {
		// when window width is >= 320px
		1: {
			slidesPerView: 1.1,
		},
		// when window width is >= 768px
		576: {
			slidesPerView: 2.3,
		},
		// when window width is >= 993px
		993: {
			slidesPerView: 2.7,
		},
		// when window width is >= 1140x
		1140: {
			slidesPerView: 3.3,
		},
		// when window width is >= 1290px
		1290: {
			slidesPerView: 3.5,
		}
	}
});

var swiper = new Swiper(".announcement-slider", {
	slidesPerView: 1,
	loop: true,
	speed: 1000,
	autoplay: {
		delay: 4000,
		disableOnInteraction: true,
		
	},
});
// testimonial slider js end--

// product slider js start--
let mql = window.matchMedia("(max-width: 767px)");
if (mql.matches) {
	var swiper = new Swiper(".product-details-thumb-slider", {
		loop: false,
		spaceBetween: 2,
		slidesPerView: 4.2,
		breakpoints: {
			1: {
				slidesPerView: 4.2,
			},
			576: {
				slidesPerView: 5.2,
			}
		}
	});
	var swiper2 = new Swiper(".product-details-slider", {
		spaceBetween: 0,
		direction: "vertical",
		slidesPerView: "auto",
		freeMode: true,
		mousewheel: true,
		scrollbar: {
			el: ".swiper-scrollbar",
		},
		thumbs: {
			swiper: swiper,
		},
		breakpoints: {
			1: {
				freeMode: false,
				spaceBetween: 5,
				slidesPerView: 1,
				mousewheel: false,
				direction: "horizontal",
			},
			576: {
				freeMode: false,
				spaceBetween: 5,
				slidesPerView: 1,
				mousewheel: false,
				direction: "horizontal",
			},
			767: {
				spaceBetween: 0,
				direction: "vertical",
				slidesPerView: "auto",
				freeMode: true,
				mousewheel: true,
			},
			1024: {
				spaceBetween: 0,
				direction: "vertical",
				slidesPerView: "auto",
				freeMode: true,
				mousewheel: true,
			}
		}
	});
} else {
	var swiper2 = new Swiper(".product-details-slider", {
		spaceBetween: 0,
		direction: "vertical",
		slidesPerView: "auto",
		freeMode: true,
		mousewheel: true,
		scrollbar: {
			el: ".swiper-scrollbar",
		},
	});

}

// product slider js end--


// cart item increase
function itemPlus(e, el) {
  var id = $(el).data("id");
  var qty = $(el).prev().val();
  qty = parseInt(qty) + 1;
  var $this = $(e);

  console.log('qty ' + qty);
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: qty,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
      $(el).prev().val(qty);
      // console.log('Increased');
    },
    error: function (err) {
      console.log("Error");
    },
  });
}
// cart item decrease
function itemMinus(e, el) {
  var id = $(el).data("id");
  var qty = $(el).next().val();
  qty = parseInt(qty) - 1;
  var $this = $(e);
  console.log('qty ' + qty);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: qty,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
      if (qty >= 1) {
		
        $(el).next().val(qty);
      }
    },
    error: function (err) {
      console.log("Error");
    },
  });
}
// cart item Remove
function itemRemoved(e, el) {
  var id = $(el).data("id");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: 0,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
    },
    error: function (err) {
      console.log("Error");
    },
  });
}

function removeGiftItem(itemKey) {
	console.log(itemKey,"item key")
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: itemKey,
      quantity: 0
    })
  }).then(() => {
    cart_drawer_update();
  });
}

function cart_drawer_update() {
  fetch("/?section_id=side-cart")
    .then((reponse) => reponse.text())
    .then((cartData) => {
      var cart_html = $(cartData);
  // Replace inside only, not the whole wrapper
      $("#cart_items").html($("#cart_items", cart_html).html());

      $(".cart_footer").html($(".cart_footer", cart_html).html());
      $("#progress").html($("#progress", cart_html).html());

      // Also update gift offer safely
      $("#giftOffer").html($("#giftOffer", cart_html).html());
    });

  $.getJSON("/cart.js", function (cart) {
		// REMOVE GIFT PRODUCT IF CART TOTAL IS BELOW 100 OR 150
	var cart_total = cart.total_price / 100;
	console.log(cart_total,"cart total")
	 cart.items.forEach(item => {
		if (!item.properties || !item.properties.gift) return;
    	let giftName = item.properties.gift;
		// Remove 100 Spend Gift if cart < 100
    if (cart_total < 100 && giftName.includes("100 Spend Gift")) {
      removeGiftItem(item.key);
    }
	 if (cart_total < 150 && giftName.includes("150 Spend Gift")) {
      removeGiftItem(item.key);
    }
	 });
	//  end here
    var total_items = cart.item_count;

	if(total_items > 0) {
		$('.cart-sidebar').removeClass('empty_cart')
	}else {
		$('.cart-sidebar').addClass('empty_cart')
	}

    $(".side-cart-item-number").text(total_items);
	$(".cart_count").text(total_items);



    
  });
}



// timer js start--
var timeInSecs;
var ticker;

function startTimer(secs) {
	timeInSecs = parseInt(secs);
	ticker = setInterval("tick()", 1000);
}

function tick() {
	var secs = timeInSecs;
	if (secs > 0) {
		timeInSecs--;
	} else {
		clearInterval(ticker);
		startTimer(10 * 60); // 10 minutes in seconds
	}

	var mins = Math.floor(secs / 60);
	secs %= 60;
	var pretty = ((mins < 10) ? "0" : "") + mins + ":" + ((secs < 10) ? "0" : "") + secs;

	document.getElementById("side_cart_timer").innerHTML = pretty;
}

startTimer(10 * 60); // 10 minutes in seconds
// timer js end--

// modal js start---
// var body = document.querySelector("body");
// var modal = document.querySelector(".masurement-modal");
// var measurement_guide_modal_btn = document.querySelector(".measurement-guide-modal-btn");
// var closeButton = document.querySelector(".modal-close-button");

// function toggleModal() {
// 	modal.classList.toggle("show-modal");
// 	body.classList.toggle("active");
// }

// function windowOnClick(event) {
// 	if (event.target === modal) {
// 		toggleModal();
// 	}
// }

// measurement_guide_modal_btn.addEventListener("click", toggleModal);
// closeButton.addEventListener("click", toggleModal);
// window.addEventListener("click", windowOnClick);
// modal js end---



// progesss-bar js start--
const progress = document.querySelector('.progress');
progress.addEventListener('input', function () {
	const value = this.value;
	this.style.background = `linear-gradient(to right,rgb(36, 40, 51) 0%,rgb(36, 40, 51) ${value}%,rgb(216, 216, 216) ${value}%)`
})
// progesss-bar js end--


new Swiper(".megaSwipertitle", {
		slidesPerView: 3.5,
		spaceBetween: 5,
		navigation: {
		nextEl: ".swiper-button-nexttitle",
		prevEl: ".swiper-button-prevtitle",
	},
	breakpoints: {
		0: {
			slidesPerView: 3.3,
		},
		768: {
			slidesPerView: 3.3,
		},
		1024: {
			slidesPerView: 3.5,
		},
	},
});

document.querySelectorAll(".product-slider__buttons").forEach((btnWrapper) => {
  const btn = btnWrapper.querySelector(".swiper-button-next, .swiper-button-prev");
  if (!btn) return;

  btnWrapper.addEventListener("mousemove", (e) => {
    const rect = btnWrapper.getBoundingClientRect();
    const x = e.clientX - rect.left - btn.offsetWidth / 2;
    const y = e.clientY - rect.top - btn.offsetHeight / 2;

    btn.style.transform = `translate(${x}px, ${y}px)`;
  });

  btnWrapper.addEventListener("mouseleave", () => {
    btn.style.transform = "translate(0, 0)";
  });
});

document.querySelectorAll(".product-slider__section").forEach(function(section) {
    const wrapper = section.querySelector(".product-slider__wrapper");
    const mainSlider = section.querySelector(".product-slider__product-swiper");
    const thumbSlider = section.querySelector(".product-slider__image-swiper");
    const nextBtn = section.querySelector(".product-slider__buttons.product-button-next");
    const prevBtn = section.querySelector(".product-slider__buttons.product-button-prev");
    const paginationEl = section.querySelector(".product-slider__pagination.swiper-pagination");
    const swiperMain = new Swiper(mainSlider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1000,
        keyboard: true,
        autoplay: {
            delay: 1000,
            disableOnInteraction: false,
        },
        pagination: {
            el: paginationEl,
            clickable: true,
        },
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        effect: "slide",
    });

    const swiperThumb = new Swiper(thumbSlider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1000,
        watchSlidesProgress: true,
        effect: "slide",
        breakpoints: {
            0: {
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: false,
                },
            },
            767: {
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: false,
                },
            },
        },
    });

    swiperMain.controller.control = swiperThumb;
    swiperThumb.controller.control = swiperMain;
	
    wrapper.addEventListener("mouseenter", function() {
        swiperMain.autoplay?.stop();
        swiperThumb.autoplay?.stop();
    });
    wrapper.addEventListener("mouseleave", function() {
        swiperMain.autoplay?.start();
        swiperThumb.autoplay?.start();
    });
});



const swipe = new Swiper('.bestseller-section .product-slider__image-swiper', {
	loop: true,
	slidesPerView: 1,
	spaceBetween: 10,
	speed: 1000,
	watchSlidesProgress: true,
	effect: "slide",
	autoplay: {
		delay: 1000,
		disableOnInteraction: false,
	},
});
